import React, { useEffect } from 'react';
import { Box, Typography, Container, Button, Card, CardContent, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const PaymentCancel = () => {
  const theme = useTheme();
  const mode = theme.palette.mode;

  useEffect(() => {
    document.title = "Payment Cancelled | CoreTechTalks";
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute("content", "Your checkout process was cancelled. No charges were made. Return to CoreTechTalks utility tools.");
    }
  }, []);

  return (
    <Box sx={{ flexGrow: 1, py: { xs: 8, md: 12 }, minHeight: 'calc(100vh - 200px)', position: 'relative', display: 'flex', alignItems: 'center' }}>
      {/* Background decorations */}
      <Box className="glow-orb" sx={{ width: '400px', height: '400px', top: '-100px', right: '-100px', background: 'rgba(239, 68, 68, 0.08)' }} />
      <Box className="glow-orb" sx={{ width: '300px', height: '300px', bottom: '10%', left: '-150px', background: 'rgba(6, 182, 212, 0.06)' }} />

      <Container maxWidth="sm" sx={{ position: 'relative', zIndex: 2 }}>
        <Card 
          sx={{ 
            p: { xs: 2, sm: 4 }, 
            textAlign: 'center',
            '&:hover': { transform: 'none' } // static status card, don't hover float
          }}
        >
          <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: { xs: 3, sm: 4 } }}>
            <Box 
              sx={{ 
                display: 'inline-flex',
                p: 2,
                borderRadius: '50%',
                bgcolor: mode === 'light' ? 'rgba(239, 68, 68, 0.08)' : 'rgba(239, 68, 68, 0.15)',
                color: 'error.main',
                mb: 3,
                boxShadow: '0 0 20px rgba(239, 68, 68, 0.1)'
              }}
            >
              <CancelOutlinedIcon sx={{ fontSize: '48px' }} />
            </Box>

            <Typography variant="h2" component="h1" sx={{ mb: 2, fontSize: { xs: '32px', md: '40px' }, fontWeight: 800 }}>
              Checkout <span style={{ color: theme.palette.error.main, fontFamily: '"Outfit", sans-serif' }}>Cancelled</span>
            </Typography>

            <Typography variant="body1" color="text.secondary" sx={{ mb: 4, px: { xs: 0, sm: 2 } }}>
              Your transaction was cancelled and you have not been charged. If you faced any issues with the payment, you can try again at any time.
            </Typography>

            <Button 
              id="btn-cancel-back-to-tools"
              component={Link} 
              to="/tools" 
              variant="contained" 
              color="primary"
              size="large"
              startIcon={<ArrowBackIcon />}
              sx={{ 
                py: 1.5, 
                px: 4,
                fontSize: '15px',
                borderRadius: '12px'
              }}
            >
              Return to Tools
            </Button>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default PaymentCancel;
